import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import LabContent from './LabContent';
import './css/Lab.css';

const Lab = ({ isCollapsed, toggleSidebar }) => {
    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <LabContent />
            </div>
        </div>
    );
};

export default Lab;
